/** Shared shell for text-entry controls, so Input, Textarea and Select cannot
 *  drift apart. border-border and border-ink-200 are the same value; the
 *  semantic name is used here because these are roles, not shades. */
export const FIELD_BASE =
  'px-3 py-2 text-sm text-ink-1000 bg-white border border-border rounded-[2px] ' +
  'font-[inherit] focus:outline-none focus:border-ink-1000 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'
